export const DashboardForms = () => {

  const $deleteDataFormWrapper = $('.js-dashboardDeleteDataForm')
  const $deleteDataForm = $('.js-dashboardDeleteDataForm__form')

  if ($deleteDataFormWrapper.length) {
    initDeleteDataForm()
  }

  function initDeleteDataForm() {
    let confirmed = false

    const $deleteBtn = $('.js-dashboardDeleteDataForm__deleteBtn')
    const $confirmBtn = $('.js-dashboardDeleteDataForm__confirmBtn')
    const $confirmationText = $('.js-dashboardDeleteDataForm__confirmationText')
    const $introText = $('.js-dashboardDeleteDataForm__introText')
    const $warningBox = $('.js-dashboardDeleteDataForm__warningBox')
    const $confirmationInput = $('.js-dashboardDeleteDataForm__confirmationInput')

    $deleteDataForm.on('submit', function(e) {
      if (!confirmed) {
        e.preventDefault()
      }
    })

    $deleteBtn.on('click', function(e) {
      e.preventDefault()
      $introText.addClass('d-none')
      $(this).addClass('d-none')

      $confirmationText.removeClass('d-none')
      $warningBox.removeClass('d-none')
      $confirmBtn.removeClass('d-none')

      confirmed = true
      $('.js-dashboardDeleteDataForm__introFormField').addClass('d-none')
      $('.js-dashboardDeleteDataForm__confirmationFormField').removeClass('d-none')
    })

    $confirmationInput.on('input', function(e) {
      if ('delete' === e.target.value) {
        $confirmBtn.attr('disabled', false)
      } else {
        $confirmBtn.attr('disabled', true)
      }
    })


  }

}

export const DashboardSearchFilters = () => {
  const $select = $('.js-dashboardScreen__searchFiltersSortSelect')
  const $pager = $('.js-dashboardScreen__searchFiltersPager')
  const $prev = $('.js-dashboardScreen__searchFiltersPagerPrev')
  const $next = $('.js-dashboardScreen__searchFiltersPagerNext')
  const urlParams = new URLSearchParams(window.location.search)
  const initSort = () => {
    $select.on('change', function() {
      const value = $(this).val()
      const sortParam = urlParams.get('sort');
      if (value === sortParam ) return
      var url = new URL(window.location.href);
      url.searchParams.set('sort', value);
      window.location.href = url.toString();
    })
  }
  const initPager = () => {
    const lastPage = $pager.data('last-page')
    $prev.on('click', () => {
      const pageParam = urlParams.get('page');
      const page = parseInt(pageParam) || 1;
      if (page < 2) return;
      var url = new URL(window.location.href);
      url.searchParams.set('page', page - 1);
      window.location.href = url.toString();
    })
    $next.on('click', () => {
      const pageParam = urlParams.get('page');
      const page = parseInt(pageParam) || 1;
      if (page >= lastPage) return;
      var url = new URL(window.location.href);
      url.searchParams.set('page', page + 1);
      window.location.href = url.toString();
    })
  }
  initSort()
  initPager()
}